import React, { useState } from "react";
import "./style1.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faEnvelope,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import SocialNavBar from "../../Components/ui/SocialNavBar";

const ContactForm = () => {
  // For Captcha code
  const randomString = Math.random().toString(36).slice(8);
  const [captcha, setCaptcha] = useState(randomString);
  const [text, setText] = useState("");
  const [valid] = useState(false);

  // For Submit for Data
  const [EASYGST, setEASYGST] = useState({
    name: "",
    mobile: "",
    mobile2: "",
    email: "",
    address1: "",
    address2: "",
    area: "",
    city: "",
    state: "",
    pin_code: "",
    description: "",
    profession: "",
    product: "EASYGST",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEASYGST({
      ...EASYGST,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const Authanantication = btoa("electrocom:electrocom");

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${Authanantication}`,
      },
      body: JSON.stringify(EASYGST),
    };

    fetch("http://espl.local:8080/espl/api/send-inquiry", requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((EASYGST) => {
        console.log("Form submitted successfully:", EASYGST);
        alert("Thank you For Messageing");
        setCaptcha(Math.random().toString(36).slice(8));
        setText("");
        setEASYGST({
          name: "",
          mobile: "",
          mobile2: "",
          email: "",
          address1: "",
          address2: "",
          area: "",
          city: "",
          state: "",
          pin_code: "",
          description: "",
          profession: "",
          product: "EASYGST"
        });
      })

      .catch((error) => {
        console.error("Error submitting form:", error);
      });
  };

  const fields = [
    {
      id: "name",
      name: "name",
      placeholder: "Full Name",
      type: "text",
    },
    {
      id: "profession",
      name: "profession",
      placeholder: "Profession",
      type: "text",
    },
    {
      id: "mobile",
      name: "mobile",
      placeholder: "Mobile Number",
      type: "text",
    },
    { id: "email", name: "email", placeholder: "Email", type: "email" },
    {
      id: "city",
      name: "city",
      placeholder: "City",
      type: "text",
    },
    // {
    //   id: "state",
    //   name: "state",
    //   placeholder: "State",
    //   type: "text",
    // },
    // {
    //   id: "description",
    //   name: "description",
    //   placeholder: "Remark",
    //   type: "text",
    //   extraClass: "pb-10",
    //   cols: "col-span-2",
    // },
  ];

  // For captcha code
  const refreshString = () => {
    setCaptcha(Math.random().toString(36).slice(8));
  }

  return (
    <div
      id="contact"
      className="bg-white relative w-full z-40 flex justify-center"
    >
      <div className="container1 ">
        <span className="big-circle"></span>
        <div className="relative w-full max-w-7xl">
          <img src="img/shape.png" className="square" alt="" />
          <div className="form">
            <div className="contact-info">
              <h3 className="text-center text-2xl font-semibold text-[#519980] mb-0">
                Connect Us
              </h3>
              <div className="info">
                <div className="flex items-start">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="mt-[6px]" />{" "}
                  &nbsp; &nbsp;
                  <p className="mb-0 text-[#3d4f5f] text-lg">
                    505, Sukhsagar Complex, <br /> Nr. Fortune Landmark, <br />
                    Usmanpura Cross Road,
                    <br /> Ahmedabad - 380013
                  </p>
                </div>
                <div className="information">
                  <p className="mb-0 text-[#3d4f5f] text-lg">
                    <div>
                      <FontAwesomeIcon icon={faEnvelope} />
                      <a
                        href="mailto:info@easyofficesoftware.com"
                        className="ml-2"
                      >
                        info@easyofficesoftware.com
                      </a>
                    </div>
                    <div>
                      <FontAwesomeIcon icon={faEnvelope} />
                      <a href="mailto:info@electrocom.in" className="ml-2">
                        info@electrocom.in
                      </a>
                    </div>
                  </p>
                </div>
                <div className="information">
                  <p className="mb-0 text-[#3d4f5f] text-lg">
                    <div>
                      <FontAwesomeIcon icon={faPhone} />
                      <a href="tel:07927562400" className="text-[#3d4f5f] ml-2">
                        079-27562400
                      </a>
                    </div>{" "}
                    <div>
                      <FontAwesomeIcon icon={faPhone} />
                      <a href="tel:07927562400" className="text-[#3d4f5f] ml-2">
                        079-35014600
                      </a>
                    </div>{" "}
                  </p>
                </div>
                <div className="information">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-whatsapp"
                    viewBox="0 0 16 16"
                    className="mr-3"
                  >
                    <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                  </svg>
                  <a
                    href="whatsapp://send?text=Hello!&phone=+917046062400"
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#3d4f5f] text-lg"
                  >
                    +91 70460 62400
                  </a>
                </div>
              </div>

              <div className="social-media">
                <p>Connect with us :</p>
                <div className="social-icons">
                  <SocialNavBar />
                </div>
              </div>
            </div>

            <div className="contact-form">
              <span className="circle one"></span>
              <span className="circle two"></span>

              <form onSubmit={handleSubmit} autoComplete="off">
                <h3 className="mb-0 text-white text-2xl text-center font-semibold">
                  Inquire
                </h3>
                <div className="grid grid-cols-2 gap-3 mt-8">
                  {fields.map(
                    ({
                      id,
                      name,
                      placeholder,
                      type,
                      extraClass,
                      cols = "",
                    }) => (
                      <div className={`relative ${cols}`} key={id}>
                        <input
                          id={id}
                          name={name}
                          placeholder={placeholder}
                          type={type}
                          value={EASYGST[name]}
                          onChange={handleChange}
                          className={`border rounded-lg w-full text-white border-white py-2 px-3 focus:border-2 focus:border-white placeholder-white transition-colors focus:outline-none bg-inherit ${extraClass}`}
                          required={id === "name" && "mobile" && "city"}
                        />
                      </div>
                    )
                  )}
                  <div className={`relative`}>
                    <select
                      name="state"
                      id="state"
                      onChange={handleChange}
                      required
                      className={`border rounded-lg w-full text-white border-white py-2 px-3 focus:border-2 focus:border-white placeholder-white transition-colors focus:outline-none bg-inherit`}
                    >
                      <optgroup className="bg-gray-600">
                        <option value="1" className="border-gray-400">
                          State{" "}
                        </option>
                        <option value="39">Andaman and Nicobar Islands</option>
                        <option value="2">Andhra Pradesh</option>
                        <option value="3">Arunachal Pradesh</option>
                        <option value="4">Assam</option>
                        <option value="5">Bihar</option>
                        <option value="6">Chandigarh</option>
                        <option value="7">Chhattisgarh</option>
                        <option value="8">Dadra and Nagar Haveli</option>
                        <option value="9">Daman and Diu</option>
                        <option value="10">Delhi-NCR</option>
                        <option value="11">Goa</option>
                        <option value="12">Gujarat</option>
                        <option value="13">Haryana</option>
                        <option value="14">Himachal Pradesh</option>
                        <option value="15">Jammu and Kashmir</option>
                        <option value="16">Jharkhand</option>
                        <option value="17">Karnataka</option>
                        <option value="18">Kenmore</option>
                        <option value="19">Kerala</option>
                        <option value="20">Lakshadweep</option>
                        <option value="21">Madhya Pradesh</option>
                        <option value="22">Maharashtra</option>
                        <option value="23">Manipur</option>
                        <option value="24">Meghalaya</option>
                        <option value="25">Mizoram</option>
                        <option value="26">Nagaland</option>
                        <option value="27">Narora</option>
                        <option value="28">Natwar</option>
                        <option value="29">Odisha</option>
                        <option value="30">Paschim Medinipur</option>
                        <option value="31">Pondicherry</option>
                        <option value="32">Punjab</option>
                        <option value="33">Rajasthan</option>
                        <option value="34">Sikkim</option>
                        <option value="35">Tamil Nadu</option>
                        <option value="36">Telangana</option>
                        <option value="37">Tripura</option>
                        <option value="38">West Bengal</option>
                      </optgroup>
                    </select>
                  </div>
                  <div className="relative col-span-2">
                    <input
                      id="description"
                      name="description"
                      // value={description}
                      placeholder="Remark"
                      onChange={handleChange}
                      className={`border pb-10 rounded-lg w-full text-white border-white py-2 px-3 focus:border-2 focus:border-white placeholder-white transition-colors focus:outline-none bg-inherit`}
                    />
                  </div>
                </div>

                {/* Captcha Code */}
                <div className="flex justify-center items-center mt-3 py-2">
                  <div className="flex items-center bg-gray-100 px-2 py-1">
                    <div className="mr-2 text-black line-through text-4xl">
                      {captcha}
                    </div>
                    <button onClick={() => refreshString()}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="black"
                        class="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                      </svg>
                    </button>
                  </div>
                  <div className="ml-4">
                    <textarea
                      name="Enter Captcha"
                      value={text}
                      cols="15"
                      rows="1"
                      className="px-4 py-1"
                      placeholder="Enter Captcha..."
                      error={valid}
                      onChange={(e) => setText(e.target.value)}
                      helperText={valid && "Invalid Captcha"}
                    ></textarea>
                  </div>
                  <div>
                    <p
                      className={`mb-0 ml-3 text-black ${
                        text.length > 0 ? "block" : "hidden"
                      } ${text === captcha ? "hidden" : ""}`}
                    >
                      Enter Valid Captcha
                    </p>
                  </div>
                </div>
                <div className="mt-3">
                  <button
                    type="submit"
                    className="btn"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    disabled={text !== captcha}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
